





import Vue from "vue";
export default Vue.extend({
  name: "base-card",
  computed: {
    cssClasses() {
      return {
        "raw-on-mobile": this.rawMobile,
        "raw-on-desktop": this.rawDesktop
      };
    }
  },
  props: {
    rawMobile: {
      type: Boolean,
      default: false
    },
    rawDesktop: {
      type: Boolean,
      default: false
    },
    gray: {
      type: Boolean
    }
  }
});
